import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ClientTransfer = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ClientTransfer' className='file-pdf-document'>
            <div className='file-template'>
                
            <table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Client Name:</span></td>
        <td className='w-375'><span className='eleHeader'>CID#:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtClientName' name='txtClientName' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtCid' name='txtCid' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Insurance Company and ID#:</span></td>
        <td className='w-375'><span className='eleHeader'>Current Diagnosis (DSM 5 & ICD-10):</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtInsuranceCompany' name='txtInsuranceCompany' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtCurrentDiagnosis' name='txtCurrentDiagnosis' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-375'><span className='eleHeader'>Transfer Date:</span></td>
        <td className='w-375'>&nbsp;</td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='date' id='txtTransferDate' name='txtTransferDate' className='add-only' /></td>
        <td className='w-375'>&nbsp;</td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-500'><span className='eleHeader'>Documentation Type</span></td>
        <td className='w-250'><span className='eleHeader'>Due Date</span></td>
    </tr>
    <tr>
        <td className='w-500'>Annual Bio-Psychosocial Assessment </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_1' name='txtDueDate_1' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Annual Psychosocial Assessment (TCM) </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_2' name='txtDueDate_2' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Treatment Plan/Review  </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_3' name='txtDueDate_3' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Service Plan/Review (TCM) </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_4' name='txtDueDate_4' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Release of Private Health Information Form </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_5' name='txtDueDate_5' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Appendix I/J (TCM) </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_6' name='txtDueDate_6' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>School Release Form </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_7' name='txtDueDate_7' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Primary Care Physician Notification Form  </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_8' name='txtDueDate_8' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Therapeutic Behavioral On-Site Certification of Eligibility Form </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_9' name='txtDueDate_9' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>CFARS/FARS </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_10' name='txtDueDate_10' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-500'>Authorization Lapse Date </td>
        <td className='w-250'>
            <input type='date' id='txtDueDate_11' name='txtDueDate_11' className='add-only' /></td>
    </tr>
</table>
<p>
    <span className='eleHeader'>Please use this space to document the reason for transfer and any Information regarding client and/or client's family that is or will be vital for client's continuity of care</span>
    <span className='small block'>(e.g., Baker Acts, DCF involvement or abuse reports, challenging parent/guardian, client preferences regarding female or male provider, paperwork that needs attention ASAP, other agencies involved, authorizations available, and etc.)</span>
    <textarea id='txtContinuityOfCare' name='txtContinuityOfCare' className='formTextarea dd'></textarea>
</p>

<table>
    <tr>
        <td className='signature w-500'>&nbsp;</td>
        <td className='signature w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-500'>Former Provider Signature:</td>
        <td className='small w-250'>Date:</td>
    </tr>
    <tr>
        <td className='signature w-500'>&nbsp;</td>
        <td className='signature w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-500'>Director/Department Manager Signature:</td>
        <td className='small w-250'>Date:</td>
    </tr>
    <tr>
        <td className='signature w-500'>&nbsp;</td>
        <td className='signature w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-500'>Receiving Provider Signature:</td>
        <td className='small w-250'>Date:</td>
    </tr>
</table>
<p>
    CLIENT WILL NOT BE TRANSFERRED TO RECEIVING PROVIDER IF THIS FORM IS NOT COMPLETED
</p>

                
            </div>
        </form>

    )
}











